import type { MfaStatusTypes } from '../../Core/Users/models/mfa.model';
import { MfaApiModel } from '../users/models/mfa.api.model';

export type LoginResponse = LoginSuccessResponse | LoginMfaValidationRequiredResponse | LoginSSORedirectResponse;

export interface LoginSuccessResponse {
    token: string;
    agilityPreflight: {
        passwordChangeNeeded: boolean;
        htmlLoginResponseExpected: boolean;
    };
    // Named in the backend, we don't control this
    // eslint-disable-next-line @typescript-eslint/naming-convention
    expires_at: Date;
}

export function isLoginSuccessResponse(res: LoginResponse): res is LoginSuccessResponse {
    return 'agilityPreflight' in res || 'token' in res;
}

export interface LoginMfaValidationRequiredResponse {
    status: MfaStatusTypes;
    allowedMfaMethods: MfaApiModel[];
    verifiedMfaMethods: MfaApiModel[];
}
export function isLoginMfaValidationRequiredResponse(res: LoginResponse): res is LoginMfaValidationRequiredResponse {
    return 'allowedMfaMethods' in res && 'verifiedMfaMethods' in res && 'status' in res;
}

export interface LoginSSORedirectResponse {
    redirectUri: string;
}
export function isLoginSSORedirectResponse(res: LoginResponse): res is LoginSSORedirectResponse {
    return 'redirectUri' in res;
}
